import React from "react";
import './Actualites.css';
const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Actualites extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectFileImages: null,
            loaded: false
        };
    }

    onChangeHandler = event => {
        this.setState({
            selectFileImages: event.target.files[0],
            loaded: false
        });
    }

    render() {
        return (
            <div className="actualite column">
                <div className="img-actu">
                    <img className="wi-12" alt={this.props.alt} src={SERVER_ADDRESS + '/images/' + this.props.liens} />
                </div>
                <div className="column article align-items-center">
                    <h2 className="title_actualite">{this.props.titre}</h2>
                    <p className="article-p">{this.props.text}</p>
                </div>
            </div>
        )
    }
}

export default Actualites;
